import { Modal, IModalProps } from '../../Modal';
import * as React from 'react';
import Button from '../../Button';
import './Warning.css';


export interface IWarningProps extends IModalProps {
  warningMessage: string | JSX.Element;
}

export interface IWarningState {
}

export default class WarningModal extends React.Component<IWarningProps, IWarningState> {
  constructor(props: IWarningProps) {
    super(props);
  }

  onOk = () => {
    this.props.onClose();
  }

  onClose = () => {
    this.props.onClose();
  }

  render() {
    return (
      <Modal show={this.props.show} className="warning-modal" onClose={this.onClose}>
        <Modal.Header>
          <Modal.Title>
            <h5>Warning</h5>
          </Modal.Title>
          <Button bsClass="close" onClick={this.onClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <div className="warning-text">
            <div>{this.props.warningMessage}</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.onOk}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/WarningModal/WarningModal.tsx